import { withTheme } from 'theme';
import material3 from 'theme/material3';

const container = withTheme((theme) => ({
  width: '90%',
  maxWidth: '840px',
  paddingBottom: '64px',
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}));

const introText = withTheme(() => ({
  width: '100%',
  maxWidth: '600px',
  color: material3.color.textSecondary
}));

const sectionTitle = withTheme(() => ({
  width: '100%',
  maxWidth: '600px',
  color: material3.color.textPrimary
}));

const resultsContainer = withTheme(() => ({
  width: '100%'
}));

const emptyState = withTheme((theme) => ({
  width: '100%',
  maxWidth: '600px',
  padding: theme.spacing(3),
  border: `1px dashed ${material3.color.outline}`,
  borderRadius: material3.shape.large,
  background: material3.color.surfaceContainerLow,
  color: material3.color.textSecondary,
  textAlign: 'center'
}));

const styles = {
  container,
  introText,
  sectionTitle,
  resultsContainer,
  emptyState
};

export default styles;
